import { useCallback, useEffect, useState } from 'react';
import { useZakeke } from 'zakeke-configurator-react';
import * as QRCode from 'qrcode';

import { PlatformsType } from '../../core';

const useAr = () => {
  const { isSceneArEnabled, IS_IOS, IS_ANDROID, getQrCodeArUrl, getMobileArUrl, openArMobile } = useZakeke();
  const [isArLoading, setArLoading] = useState(false);
  const [isMobile, seIsMobile] = useState(false);

  const checkIsMobile = useCallback(() => IS_IOS || IS_ANDROID, [IS_IOS, IS_ANDROID]);

  useEffect(() => {
    if (checkIsMobile() !== isMobile) {
      seIsMobile(checkIsMobile());
    }
  }, [checkIsMobile, isMobile]);

  const showArMobile = async () => {
    setArLoading(true);
    try {
      const url = await getMobileArUrl();
      if (url && typeof url === 'string') {
        await openArMobile(url);
      } else {
        throw new Error('Zakeke mobile ar url is empty');
      }
    } catch (ex) {
      console.error(ex);
      throw ex;
    } finally {
      setArLoading(false);
    }
  };

  const getPlatformArUrl = async (platform: PlatformsType): Promise<string> => {
    setArLoading(true);
    try {
      const url = await getQrCodeArUrl(platform);
      return await QRCode.toDataURL(url);
    } catch (ex) {
      console.error(ex);
      throw ex;
    } finally {
      setArLoading(false);
    }
  };

  return {
    isArLoading,
    isMobile,
    showArMobile,
    isEnable: isSceneArEnabled,
    getPlatformArUrl,
  };
};

export { useAr };
